import { render } from "./loader.vue?vue&type=template&id=274b37ee&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=274b37ee&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274b37ee"]])

export default __exports__